module.exports = __webpack_public_path__ + "static/media/dats_logo.6060d10a.png";